// extracted by mini-css-extract-plugin
export default {"base":"RSVMap_base__HMhvk","map":"RSVMap_map__-ERZ-","mapLegend":"RSVMap_mapLegend__qeAvW"};